import React from 'react'

import HospitalHomeDoctorRegister from 'presentation/hospital/pages/Home/DoctorRegister'

export default function makeHospitalDoctorRegisterHome() {
  return <HospitalHomeDoctorRegister />
}
